import { toTitleCase } from "../../../../Utils/stringUtls";

const ProgramVelocityLimitOverview = ({ data }) => {
  const {
    pf_pvl_caf = "",
    pf_pvl_cal = "",
    pf_pvl_max_num_payments = "",
    pf_pvl_max_cred_line = "",
    pf_pvl_min_trans_amount = "",
    pf_pvl_max_trans_amount = "",
    pf_pvl_min_int_trans_amount = "",
    pf_pvl_max_int_trans_amount = "",
  } = data["5_1"];
  return (
    <div
      className="forms-instance"
      style={{ color: "#111", marginTop: "16px" }}
    >
      <div i2c-grid="grid gap-sm">
        <div i2c-grid="12@md" className="fw-700 overview-val-text font-bold">
          Program Velocity Limits
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Cash Advance Frequency (Daily)
          </div>
          <div className="overview-val-text">
            {pf_pvl_caf?.length ? toTitleCase(pf_pvl_caf) : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Cash Advance Limit Amount (Daily)
          </div>
          <div className="overview-val-text">
            {pf_pvl_cal?.length ? toTitleCase(pf_pvl_cal) : "-"}
          </div>
        </div>

        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Maximum Number of Payments (Daily)
          </div>
          <div className="overview-val-text">
            {pf_pvl_max_num_payments?.length ? pf_pvl_max_num_payments : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Maximum Credit Line
          </div>
          <div className="overview-val-text">
            {pf_pvl_max_cred_line?.length ? pf_pvl_max_cred_line : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Minimum Transaction Amount
          </div>
          <div className="overview-val-text">
            {pf_pvl_min_trans_amount?.length
              ? toTitleCase(pf_pvl_min_trans_amount)
              : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Maximum Transaction Amount
          </div>
          <div className="overview-val-text">
            {pf_pvl_max_trans_amount?.length
              ? toTitleCase(pf_pvl_max_trans_amount)
              : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Minimum International Transaction Amount
          </div>
          <div className="overview-val-text">
            {pf_pvl_min_int_trans_amount?.length
              ? toTitleCase(pf_pvl_min_int_trans_amount)
              : "-"}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="overview-help-text font-bold">
            Maximum International Transaction Amount
          </div>
          <div className="overview-val-text">
            {pf_pvl_max_int_trans_amount?.length
              ? toTitleCase(pf_pvl_max_int_trans_amount)
              : "-"}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProgramVelocityLimitOverview;
